// Textos de cuenta, KYC, clave, tarjetas, ayuda, asistente y alertas: { es: {...}, en: {...}, pt: {...} }
export default {
  es: {
    'cuenta.tabDatos': 'Mis datos',
    'cuenta.tabVerificacion': 'Centro de verificación',
    'kyc.queEsTitulo': '¿Qué es KYC y para qué sirve?',
    'kyc.queEsP1': 'KYC es el nombre que se le da al proceso de verificación de la identidad de un cliente. Este término, que se está convirtiendo en una expresión común, proviene del sector bancario. Las instituciones financieras siempre deben poder identificar a sus clientes cuando abren una nueva cuenta.',
    'kyc.queEsP2': 'Los objetivos de las directrices de KYC son evitar que los bancos o entidades financieras sean utilizados, intencionalmente o no, por elementos criminales para actividades de lavado de dinero. Los procedimientos relacionados también permiten a los bancos entender mejor a sus clientes y sus transacciones financieras.',
    'cuenta.anadirWallet': 'Añadir wallet',
    'cuenta.anadirCuenta': 'Añadir cuenta',
    'cuenta.anadirPrimeraWallet': 'Añadir mi primera wallet',
    'cuenta.anadirPrimera': 'Añadir la primera',
    'cuenta.banco': 'Banco',
    'cuenta.cuentaTipo': 'Cuenta',
    'cuenta.eliminarNombre': 'Eliminar {nombre}',
    'cuenta.eliminando': 'Eliminando…',
    'cuenta.eliminar': 'Eliminar',
    'cuenta.cuentaGuardada': 'Cuenta guardada.',
    'cuenta.confirmarEliminar': '¿Eliminar {nombre}?',
    'cuenta.cuentaEliminada': 'Cuenta eliminada.',
    'cuenta.noSeEliminoCuenta': 'No se pudo eliminar la cuenta.',
    'cuenta.walletsTitulo': 'Wallets USDT',
    'cuenta.walletsAyuda': 'Los retiros en USDT solo se envían a estas wallets.',
    'cuenta.walletsVacio': 'Aún no tienes wallets guardadas.',
    'cuenta.panamaTitulo': 'Cuentas en Panamá',
    'cuenta.panamaAyuda': 'Tus cuentas bancarias locales.',
    'cuenta.panamaVacio': 'Aún no tienes cuentas en Panamá.',
    'cuenta.internacionalesTitulo': 'Cuentas internacionales',
    'cuenta.internacionalesAyuda': 'Cuentas en bancos fuera de Panamá.',
    'cuenta.internacionalesVacio': 'Aún no tienes cuentas internacionales.',
    'srv:Beneficiario desactivado correctamente': 'Beneficiario desactivado correctamente',
    'srv:Beneficiario creado correctamente': 'Beneficiario creado correctamente',
    'srv:Beneficiario actualizado correctamente': 'Beneficiario actualizado correctamente',
    'srv:Esa wallet ya está guardada.': 'Esa wallet ya está guardada.',
    'cuenta.perfilDe': 'Perfil de',
    'cuenta.usuario': 'Usuario',
    'cuenta.plataforma': 'Plataforma de Crecimiento Financiero',
    'cuenta.tabDatosPersonales': 'Mis Datos Personales',
    'cuenta.tabPrivacidad': 'Privacidad & Seguridad',
    'cuenta.tabCuentasBancarias': 'Cuentas Bancarias',
    'cuenta.sinAgregar': 'Sin agregar',
    'cuenta.actualizacionTitulo': 'Actualización de mis datos personales',
    'cuenta.bienvenida1': 'Bienvenido a tu plataforma favorita de inversiones,',
    'cuenta.bienvenida2': 'por favor completa',
    'cuenta.bienvenida3': 'los siguientes campos con tus datos personales para poder disfrutar de',
    'cuenta.obligatorios': 'Los campos con asteriscos son obligatorios *',
    'cuenta.lblNombreUsuario': '👤 Nombre de usuario:',
    'cuenta.lblCorreo': '📧 Correo electrónico:',
    'cuenta.lblReferido': '🔗 Código de referido:',
    'cuenta.lblDocumento': '🆔 Documento de identidad:',
    'cuenta.lblSexo': '⚥ Sexo:',
    'cuenta.lblSituacionLaboral': '💼 Situación laboral:',
    'cuenta.lblEmpresa': '🏢 Empresa donde labora:',
    'cuenta.lblNacimiento': '🎂 Fecha de nacimiento:',
    'cuenta.contactoTitulo': 'Información de contacto',
    'cuenta.contactoAyuda': 'Complete sus datos de contacto y dirección',
    'cuenta.lblCelular': '📱 Número de Celular:',
    'cuenta.lblDireccion': '🏠 Dirección principal:',
    'cuenta.lblCalle': '📍 Dirección Calle:',
    'cuenta.lblPostal': '✉️ Código Postal:',
    'cuenta.lblPais': '🌎 País:',
    'cuenta.lblProvincia': '🏞️ Provincia:',
    'cuenta.lblCiudad': '🏙️ Ciudad:',
    'cuenta.completarInfo': '📝 Completar información',
    'cuenta.completeInfoPersonal': 'Complete su información personal',
    'clave.errorCambiar': 'Error al cambiar la contraseña',
    'clave.todosObligatorios': 'Todos los campos son obligatorios',
    'clave.noCoincidenNuevas': 'Las nuevas contraseñas no coinciden',
    'clave.minimo8': 'La nueva contraseña debe tener al menos 8 caracteres',
    'clave.cambiarBtn': '🔒 Cambiar contraseña',
    'clave.debil': 'Débil',
    'clave.media': 'Media',
    'clave.fuerte': 'Fuerte',
    'clave.privacidadTitulo': 'Privacidad y Seguridad',
    'clave.privacidadAyuda1': 'Para nosotros es muy importante tu',
    'clave.privacidadAyuda2': 'privacidad y seguridad',
    'clave.privacidadAyuda3': '',
    'clave.recomendacion1': 'Recomendamos actualizar su contraseña 1 vez',
    'clave.recomendacion2': 'cada 30 días',
    'clave.consejo': 'Una contraseña segura debe tener al menos 8 caracteres, incluyendo mayúsculas, minúsculas, números y caracteres especiales.',
    'clave.lblActual': 'Contraseña actual',
    'clave.phActual': 'Ingrese su contraseña actual',
    'clave.lblNueva': 'Nueva contraseña',
    'clave.phNueva': 'Ingrese su nueva contraseña',
    'clave.fortaleza': 'Fortaleza:',
    'clave.lblConfirmar': 'Confirmar nueva contraseña',
    'clave.phConfirmar': 'Confirme su nueva contraseña',
    'clave.noCoinciden': 'Las contraseñas no coinciden',
    'clave.actualizarMi': 'Actualizar mi contraseña',
    'srv:Su contraseña actual no coincide con la contraseña que proporcionó. Inténtalo de nuevo..': 'Su contraseña actual no coincide con la contraseña que proporcionó. Inténtalo de nuevo..',
    'srv:La nueva contraseña no puede ser la misma que su contraseña actual. Elija una contraseña diferente.': 'La nueva contraseña no puede ser la misma que su contraseña actual. Elija una contraseña diferente.',
    'srv:Password changed successfully !': 'Password changed successfully !',
    'srv:Sua senha atual não corresponde à senha que você forneceu. Por favor, tente novamente.': 'Sua senha atual não corresponde à senha que você forneceu. Por favor, tente novamente.',
    'srv:Nova senha não pode ser igual à sua senha atual. Por favor, escolha uma senha diferente.': 'Nova senha não pode ser igual à sua senha atual. Por favor, escolha uma senha diferente.',
    'alerta.listo': 'Listo',
    'alerta.revisa': 'Revisa esto',
    'alerta.aceptar': 'Aceptar',
    'cuenta.actualizarInfo': 'Actualizar mi información',
    'cuenta.fSituacion': 'Situación laboral',
    'cuenta.fEmpresa': 'Empresa donde labora',
    'cuenta.fOcupacion': 'Ocupación laboral',
    'cuenta.fNombreApellido': 'Nombre y apellido',
    'cuenta.fDocumento': 'Documento de identidad',
    'cuenta.fNacimiento': 'Fecha de Nacimiento',
    'cuenta.fSexo': 'Sexo',
    'cuenta.fEstadoCivil': 'Estado Civil',
    'cuenta.fPais': 'País',
    'cuenta.fProvincia': 'Provincia',
    'cuenta.fCiudad': 'Ciudad',
    'cuenta.fDireccion': 'Dirección',
    'cuenta.fDireccionCompl': 'Dirección complementaria',
    'cuenta.fPostal': 'Código Postal',
    'srv:Cliente actualizado. ': 'Cliente actualizado. ',
    'srv:No es posible actualizar el cliente': 'No es posible actualizar el cliente',
    'kyc.docTitulo': 'Documento de identidad',
    'kyc.docAyuda': 'Cédula o pasaporte, por el lado de la foto. Todo el documento a la vista y sin reflejos.',
    'kyc.resTitulo': 'Comprobante de residencia',
    'kyc.resAyuda': 'Un recibo de servicios o estado de cuenta reciente, a tu nombre.',
    'kyc.selfieTitulo': 'Selfie',
    'kyc.selfieAyuda': 'Una foto tuya de frente, con buena luz y sin gafas oscuras.',
    'kyc.vistaPrevia': 'Vista previa de {titulo}',
    'kyc.cambiar': 'Cambiar',
    'kyc.elegirArchivo': 'Elegir archivo',
    'kyc.formatosMax': 'JPG, PNG o PDF · hasta {max} MB',
    'kyc.formatoNoPermitido': 'Formato no permitido. Usa JPG, PNG o PDF.',
    'kyc.superaMax': 'El archivo supera los {max} MB.',
    'kyc.enviados': 'Documentos enviados.',
    'kyc.errorSubir': 'No pudimos subir los documentos. Revisa tu conexión e intenta de nuevo.',
    'kyc.recibidosTitulo': 'Documentos recibidos',
    'kyc.recibidosDetalle': '{texto}. Los revisaremos y tu cuenta quedará habilitada al aprobarlos.',
    'kyc.continuar': 'Continuar',
    'kyc.verificaTitulo': 'Verifica tu identidad',
    'kyc.verificaAyuda': 'Es un requisito para invertir y retirar. Solo necesitas tres fotos y tarda unos minutos.',
    'kyc.soloVerificar': 'Tus documentos se usan solo para verificar tu identidad.',
    'kyc.subiendo': 'Subiendo…',
    'kyc.enviarDocs': 'Enviar documentos',
    'srv:Documentos subidos correctamente': 'Documentos subidos correctamente',
    'clave.cambiar': 'Cambiar contraseña',
    'clave.cambioTitulo': 'Cambio de contraseña',
    'clave.lblConfirmarCorta': 'Confirmar contraseña',
    'clave.phAntigua': 'Su antigua contraseña',
    'clave.phNuevaCorta': 'Su nueva contraseña',
    'clave.phConfirmarNueva': 'Confirmar su nueva contraseña',
    'clave.guardar': 'Guardar contraseña',
    'tarjeta.lblNombre': 'Nombre',
    'tarjeta.lblApellido': 'Apellido',
    'tarjeta.lblTipoDoc': 'Tipo de documento',
    'tarjeta.lblNumDoc': 'Número de documento',
    'tarjeta.lblNacimiento': 'Fecha de nacimiento',
    'tarjeta.lblSexo': 'Sexo',
    'tarjeta.lblEstadoCivil': 'Estado civil',
    'tarjeta.lblNacionalidad': 'Nacionalidad',
    'tarjeta.lblProfesion': 'Profesión u oficio',
    'tarjeta.lblCorreo': 'Correo electrónico',
    'tarjeta.lblTelefono': 'Teléfono',
    'tarjeta.lblPaisRes': 'País de residencia',
    'tarjeta.lblProvincia': 'Provincia',
    'tarjeta.lblCiudad': 'Ciudad',
    'tarjeta.lblPostal': 'Código postal',
    'tarjeta.lblCalle': 'Calle y número',
    'tarjeta.lblComplemento': 'Apartamento, casa o edificio (opcional)',
    'tarjeta.selPais': 'Selecciona un país',
    'tarjeta.selecciona': 'Selecciona',
    'tarjeta.docCedula': 'Cédula/DNI',
    'tarjeta.docPasaporte': 'Pasaporte',
    'tarjeta.sexoM': 'Masculino',
    'tarjeta.sexoF': 'Femenino',
    'tarjeta.civilSoltero': 'Soltero',
    'tarjeta.civilCasado': 'Casado',
    'tarjeta.civilDivorciado': 'Divorciado',
    'tarjeta.civilViudo': 'Viudo',
    'tarjeta.civilUnion': 'Unión libre',
    'tarjeta.tuNombre': 'TU NOMBRE',
    'tarjeta.titular': 'Titular',
    'tarjeta.tarjeta': 'Tarjeta',
    'tarjeta.prepago': 'Prepago',
    'tarjeta.notaEmision': 'Tu tarjeta se emite a tu nombre. Revisamos cada solicitud antes de aprobarla.',
    'tarjeta.solicitaTitulo': 'Solicita tu tarjeta',
    'tarjeta.solicitaAyuda': 'Confirma tus datos para pedirla.',
    'tarjeta.secPersonales': 'Datos personales',
    'tarjeta.secContacto': 'Contacto',
    'tarjeta.secResidencia': 'Dirección de residencia',
    'tarjeta.phTelefono': 'Con código de país, ej. +507 6000 0000',
    'tarjeta.confirmarDatos': 'Confirmar datos',
    'tarjeta.solicitudEnviada': 'Solicitud enviada',
    'tarjeta.revisaDatos': 'Revisa tus datos',
    'tarjeta.selOrigen': 'Selecciona la tarjeta origen',
    'tarjeta.selDestino': 'Selecciona la tarjeta destino',
    'tarjeta.montoValido': 'Ingresa un monto válido',
    'tarjeta.mismaTarjeta': 'No puedes transferir a la misma tarjeta',
    'tarjeta.transferOk': 'Transferencia realizada con éxito!',
    'tarjeta.transferError': 'Error al realizar la transferencia',
    'tarjeta.volverListado': 'Volver al listado de tarjetas',
    'tarjeta.transferirTitulo': 'Transferir entre tarjetas',
    'tarjeta.lblOrigen': 'Tarjeta Origen',
    'tarjeta.lblDestino': 'Tarjeta Destino',
    'tarjeta.seleccioneTarjeta': 'Seleccione una tarjeta',
    'tarjeta.lblMonto': 'Monto a transferir',
    'tarjeta.lblDescripcion': 'Descripción (opcional)',
    'tarjeta.phDescripcion': 'Ej: Pago de inversión',
    'tarjeta.transferirBtn': '💰 Transferir',
    'tarjeta.transferExitosa': '✅ Transferencia Exitosa',
    'tarjeta.atencion': '⚠️ Atención',
    'tarjeta.cancelada': 'Listo, la tarjeta quedó cancelada.',
    'tarjeta.noCancelada': 'No pudimos cancelar la tarjeta. Intenta de nuevo.',
    'tarjeta.completaCampos': 'Completa estos campos: {campos}.',
    'tarjeta.datosActualizados': '¡Datos actualizados con éxito! Espera por aprobación.',
    'tarjeta.errorActualizar': 'Error al actualizar',
    'tarjeta.tabLista': 'Lista de Tarjetas',
    'tarjeta.tabAgregar': 'Agregar Tarjeta',
    'tarjeta.tabTransferir': 'Transferir',
    'tarjeta.desactivarTitulo': 'Desactivar tarjeta',
    'tarjeta.cancelarSolicitud': 'Cancelar solicitud',
    'tarjeta.desactivarAviso': 'La tarjeta dejará de estar disponible. Esta acción no se puede deshacer.',
    'tarjeta.cancelarAviso': 'Dejaremos de procesar esta solicitud. Podrás pedir otra tarjeta cuando quieras.',
    'tarjeta.motivo': 'Motivo (opcional)',
    'tarjeta.volver': 'Volver',
    'tarjeta.procesando': 'Procesando…',
    'tarjeta.confirmar': 'Confirmar',
    'tarjeta.descargarMov': 'Descargar movimientos',
    'tarjeta.desde': 'Desde',
    'tarjeta.hasta': 'Hasta',
    'tarjeta.cerrar': 'Cerrar',
    'tarjeta.generando': 'Generando…',
    'tarjeta.excel': 'Excel',
    'tarjeta.pdf': 'PDF',
    'tarjeta.sinTarjetas': 'Aún no tienes tarjetas',
    'tarjeta.sinTarjetasAyuda': 'Solicita tu tarjeta Panther7 y úsala con tu saldo en USDT.',
    'tarjeta.solicitar': 'Solicitar tarjeta',
    'tarjeta.misTarjetas': 'Mis tarjetas',
    'tarjeta.solicitarOtra': 'Solicitar otra tarjeta',
    'tarjeta.numDisponible': 'Número disponible cuando se emita',
    'tarjeta.sinNombre': 'Sin nombre',
    'tarjeta.enProceso': 'EN PROCESO',
    'tarjeta.saldo': 'Saldo',
    'tarjeta.detalles': 'Detalles',
    'tarjeta.desactivar': 'Desactivar',
    'tarjeta.notaRevision': 'Revisamos cada solicitud. Te avisaremos por correo cuando esté lista.',
    'tarjeta.dBloqueado': 'Saldo bloqueado:',
    'tarjeta.dTransito': 'Saldo en tránsito:',
    'tarjeta.dNumero': 'Número de tarjeta:',
    'tarjeta.dEstatus': 'Estatus:',
    'tarjeta.dCreado': 'Creado en:',
    'tarjeta.dActualizado': 'Actualizado en:',
    'tarjeta.dTransacciones': 'transacciones',
    'tarjeta.dReferencia': 'Referencia:',
    'tarjeta.dCreadoPor': 'Creado por:',
    'tarjeta.dDescripcion': 'Descripción:',
    'tarjeta.dCantidad': 'Cantidad:',
    'tarjeta.dNinguno': 'none',
    'tarjeta.dNone': 'None',
    'tarjeta.mes1': 'enero',
    'tarjeta.mes2': 'febrero',
    'tarjeta.mes3': 'marzo',
    'tarjeta.mes4': 'abril',
    'tarjeta.mes5': 'mayo',
    'tarjeta.mes6': 'junio',
    'tarjeta.mes7': 'julio',
    'tarjeta.mes8': 'agosto',
    'tarjeta.mes9': 'septiembre',
    'tarjeta.mes10': 'octubre',
    'tarjeta.mes11': 'noviembre',
    'tarjeta.mes12': 'diciembre',
    'srv:no se pudo crear la solicitud': 'no se pudo crear la solicitud',
    'srv:No pudimos registrar tu solicitud. Intenta de nuevo en unos minutos.': 'No pudimos registrar tu solicitud. Intenta de nuevo en unos minutos.',
    'srv:No encontramos esa tarjeta.': 'No encontramos esa tarjeta.',
    'srv:Esa tarjeta ya está cancelada.': 'Esa tarjeta ya está cancelada.',
    'srv:Request created': 'Request created',
    'srv:Card desactivate': 'Card desactivate',
    'srv:PENDIENTE': 'PENDIENTE',
    'srv:APROBADO': 'APROBADO',
    'srv:RECHAZADO': 'RECHAZADO',
    'srv:EN REVISIÓN': 'EN REVISIÓN',
    'srv:EN PROCESO': 'EN PROCESO',
    'srv:CANCELADO': 'CANCELADO',
    'asistente.depositar.titulo': '¿Cómo deposito?',
    'asistente.depositar.texto': 'Puedes depositar por cripto (USDT a la wallet de Panther) o por ACH desde un banco de Panamá. Cada USDT equivale a 1 USDT en tu cuenta, sin comisión. Tu depósito queda pendiente hasta que el equipo lo verifica y lo aprueba.',
    'asistente.depositar.ir': 'Ir a Depósito',
    'asistente.retirar.titulo': '¿Cómo retiro?',
    'asistente.retirar.texto': 'Entra a Retiro, elige una wallet o cuenta bancaria que tengas guardada y el monto. Los retiros no tienen comisión y se revisan antes de enviarse, así que te llegará un correo cuando estén aprobados.',
    'asistente.retirar.ir': 'Ir a Retiro',
    'asistente.invertir.titulo': '¿Cómo invierto?',
    'asistente.invertir.texto': 'En Proyectos ves lo disponible. Elige uno, indica el monto y confirma; se descuenta de tu saldo disponible. Revisa siempre las condiciones de cada proyecto antes de confirmar. Yo no doy recomendaciones de inversión.',
    'asistente.invertir.ir': 'Ver proyectos',
    'asistente.saldo.titulo': '¿Cuánto tengo?',
    'asistente.saldo.texto': 'Disponible: {disponible}. Invertido: {invertido}. Valor de tu cuenta: {valor}.',
    'asistente.saldo.error': 'No pude leer tu saldo ahora. Revisa la pantalla de Inicio.',
    'asistente.saldo.ir': 'Ir a Inicio',
    'asistente.movimientos.titulo': 'Ver mis movimientos',
    'asistente.movimientos.texto': 'En Movimientos ves todos tus depósitos, retiros e inversiones con su estado.',
    'asistente.movimientos.ir': 'Ir a Movimientos',
    'asistente.wallet.titulo': 'Mi wallet',
    'asistente.wallet.texto': 'Tu wallet y las direcciones que guardaste están en Wallet Blockchain. Revisa bien cada dirección antes de enviar: las transferencias cripto no se pueden revertir.',
    'asistente.wallet.ir': 'Ir a Wallet',
    'asistente.verificacion.titulo': 'Verificar mi cuenta',
    'asistente.verificacion.texto': 'Completa tus datos y sube tus documentos en Mi cuenta. El equipo los revisa y te avisa por correo cuando tu cuenta queda aprobada.',
    'asistente.cuenta.ir': 'Ir a Mi cuenta',
    'asistente.clave.titulo': 'Cambiar mi clave',
    'asistente.clave.texto': 'Puedes cambiar tu clave desde Mi cuenta. Nunca compartas tu clave con nadie, ni siquiera con el equipo de Panther7.',
    'asistente.comision.titulo': '¿Hay comisiones?',
    'asistente.comision.texto': 'Los depósitos y retiros no tienen comisión. Todo se muestra en USDT.',
    'asistente.humano': 'No tengo una respuesta segura para eso. Mejor te atiende una persona del equipo: escríbenos a {correo}.',
    'asistente.saludo': 'Hola, soy el asistente de Panther7. ¿En qué te ayudo?',
    'asistente.aria': 'Asistente Panther7',
    'asistente.preguntame': 'Pregúntame',
    'asistente.cerrar': 'Cerrar',
    'asistente.escribe': 'Escribe tu pregunta',
    'asistente.enviar': 'Enviar',
    'asistente.pie': 'No doy asesoría de inversión ni muevo dinero.',
    'asistente.hablar': 'Hablar con una persona',
    'asistente.soporte': 'Escribir a soporte',
    'asistente.abrir': 'Abrir asistente',
  },
  en: {
    'cuenta.tabDatos': 'My details',
    'cuenta.tabVerificacion': 'Verification center',
    'kyc.queEsTitulo': 'What is KYC and what is it for?',
    'kyc.queEsP1': 'KYC is the name given to the process of verifying a customer\'s identity. This term, which is becoming a common expression, comes from the banking sector. Financial institutions must always be able to identify their customers when they open a new account.',
    'kyc.queEsP2': 'The goals of KYC guidelines are to prevent banks and financial institutions from being used, intentionally or not, by criminal elements for money laundering activities. The related procedures also allow banks to better understand their customers and their financial transactions.',
    'cuenta.anadirWallet': 'Add wallet',
    'cuenta.anadirCuenta': 'Add account',
    'cuenta.anadirPrimeraWallet': 'Add my first wallet',
    'cuenta.anadirPrimera': 'Add the first one',
    'cuenta.banco': 'Bank',
    'cuenta.cuentaTipo': 'Account',
    'cuenta.eliminarNombre': 'Delete {nombre}',
    'cuenta.eliminando': 'Deleting…',
    'cuenta.eliminar': 'Delete',
    'cuenta.cuentaGuardada': 'Account saved.',
    'cuenta.confirmarEliminar': 'Delete {nombre}?',
    'cuenta.cuentaEliminada': 'Account deleted.',
    'cuenta.noSeEliminoCuenta': 'The account could not be deleted.',
    'cuenta.walletsTitulo': 'USDT wallets',
    'cuenta.walletsAyuda': 'USDT withdrawals are only sent to these wallets.',
    'cuenta.walletsVacio': 'You don\'t have any saved wallets yet.',
    'cuenta.panamaTitulo': 'Accounts in Panama',
    'cuenta.panamaAyuda': 'Your local bank accounts.',
    'cuenta.panamaVacio': 'You don\'t have any accounts in Panama yet.',
    'cuenta.internacionalesTitulo': 'International accounts',
    'cuenta.internacionalesAyuda': 'Accounts at banks outside Panama.',
    'cuenta.internacionalesVacio': 'You don\'t have any international accounts yet.',
    'srv:Beneficiario desactivado correctamente': 'Beneficiary deactivated successfully',
    'srv:Beneficiario creado correctamente': 'Beneficiary created successfully',
    'srv:Beneficiario actualizado correctamente': 'Beneficiary updated successfully',
    'srv:Esa wallet ya está guardada.': 'That wallet is already saved.',
    'cuenta.perfilDe': 'Profile of',
    'cuenta.usuario': 'User',
    'cuenta.plataforma': 'Financial Growth Platform',
    'cuenta.tabDatosPersonales': 'My Personal Details',
    'cuenta.tabPrivacidad': 'Privacy & Security',
    'cuenta.tabCuentasBancarias': 'Bank Accounts',
    'cuenta.sinAgregar': 'Not added',
    'cuenta.actualizacionTitulo': 'Update my personal details',
    'cuenta.bienvenida1': 'Welcome to your favorite investment platform,',
    'cuenta.bienvenida2': 'please complete',
    'cuenta.bienvenida3': 'the following fields with your personal details so you can enjoy',
    'cuenta.obligatorios': 'Fields marked with an asterisk are required *',
    'cuenta.lblNombreUsuario': '👤 Username:',
    'cuenta.lblCorreo': '📧 Email:',
    'cuenta.lblReferido': '🔗 Referral code:',
    'cuenta.lblDocumento': '🆔 ID document:',
    'cuenta.lblSexo': '⚥ Sex:',
    'cuenta.lblSituacionLaboral': '💼 Employment status:',
    'cuenta.lblEmpresa': '🏢 Employer:',
    'cuenta.lblNacimiento': '🎂 Date of birth:',
    'cuenta.contactoTitulo': 'Contact information',
    'cuenta.contactoAyuda': 'Complete your contact and address details',
    'cuenta.lblCelular': '📱 Mobile number:',
    'cuenta.lblDireccion': '🏠 Main address:',
    'cuenta.lblCalle': '📍 Street address:',
    'cuenta.lblPostal': '✉️ Postal code:',
    'cuenta.lblPais': '🌎 Country:',
    'cuenta.lblProvincia': '🏞️ Province:',
    'cuenta.lblCiudad': '🏙️ City:',
    'cuenta.completarInfo': '📝 Complete information',
    'cuenta.completeInfoPersonal': 'Complete your personal information',
    'clave.errorCambiar': 'Error changing the password',
    'clave.todosObligatorios': 'All fields are required',
    'clave.noCoincidenNuevas': 'The new passwords do not match',
    'clave.minimo8': 'The new password must be at least 8 characters long',
    'clave.cambiarBtn': '🔒 Change password',
    'clave.debil': 'Weak',
    'clave.media': 'Medium',
    'clave.fuerte': 'Strong',
    'clave.privacidadTitulo': 'Privacy and Security',
    'clave.privacidadAyuda1': 'Your',
    'clave.privacidadAyuda2': 'privacy and security',
    'clave.privacidadAyuda3': 'are very important to us',
    'clave.recomendacion1': 'We recommend updating your password once',
    'clave.recomendacion2': 'every 30 days',
    'clave.consejo': 'A secure password must be at least 8 characters long, including uppercase and lowercase letters, numbers and special characters.',
    'clave.lblActual': 'Current password',
    'clave.phActual': 'Enter your current password',
    'clave.lblNueva': 'New password',
    'clave.phNueva': 'Enter your new password',
    'clave.fortaleza': 'Strength:',
    'clave.lblConfirmar': 'Confirm new password',
    'clave.phConfirmar': 'Confirm your new password',
    'clave.noCoinciden': 'The passwords do not match',
    'clave.actualizarMi': 'Update my password',
    'srv:Su contraseña actual no coincide con la contraseña que proporcionó. Inténtalo de nuevo..': 'Your current password does not match the password you provided. Please try again.',
    'srv:La nueva contraseña no puede ser la misma que su contraseña actual. Elija una contraseña diferente.': 'The new password cannot be the same as your current password. Please choose a different password.',
    'srv:Password changed successfully !': 'Password changed successfully!',
    'srv:Sua senha atual não corresponde à senha que você forneceu. Por favor, tente novamente.': 'Your current password does not match the password you provided. Please try again.',
    'srv:Nova senha não pode ser igual à sua senha atual. Por favor, escolha uma senha diferente.': 'The new password cannot be the same as your current password. Please choose a different password.',
    'alerta.listo': 'Done',
    'alerta.revisa': 'Please check this',
    'alerta.aceptar': 'OK',
    'cuenta.actualizarInfo': 'Update my information',
    'cuenta.fSituacion': 'Employment status',
    'cuenta.fEmpresa': 'Employer',
    'cuenta.fOcupacion': 'Occupation',
    'cuenta.fNombreApellido': 'Full name',
    'cuenta.fDocumento': 'ID document',
    'cuenta.fNacimiento': 'Date of Birth',
    'cuenta.fSexo': 'Sex',
    'cuenta.fEstadoCivil': 'Marital Status',
    'cuenta.fPais': 'Country',
    'cuenta.fProvincia': 'Province',
    'cuenta.fCiudad': 'City',
    'cuenta.fDireccion': 'Address',
    'cuenta.fDireccionCompl': 'Address line 2',
    'cuenta.fPostal': 'Postal Code',
    'srv:Cliente actualizado. ': 'Client updated. ',
    'srv:No es posible actualizar el cliente': 'Unable to update the client',
    'kyc.docTitulo': 'ID document',
    'kyc.docAyuda': 'ID card or passport, photo side. The whole document in view and without glare.',
    'kyc.resTitulo': 'Proof of residence',
    'kyc.resAyuda': 'A recent utility bill or account statement in your name.',
    'kyc.selfieTitulo': 'Selfie',
    'kyc.selfieAyuda': 'A front-facing photo of yourself, with good lighting and no dark glasses.',
    'kyc.vistaPrevia': 'Preview of {titulo}',
    'kyc.cambiar': 'Change',
    'kyc.elegirArchivo': 'Choose file',
    'kyc.formatosMax': 'JPG, PNG or PDF · up to {max} MB',
    'kyc.formatoNoPermitido': 'File format not allowed. Use JPG, PNG or PDF.',
    'kyc.superaMax': 'The file exceeds {max} MB.',
    'kyc.enviados': 'Documents sent.',
    'kyc.errorSubir': 'We could not upload your documents. Check your connection and try again.',
    'kyc.recibidosTitulo': 'Documents received',
    'kyc.recibidosDetalle': '{texto}. We will review them and your account will be enabled once they are approved.',
    'kyc.continuar': 'Continue',
    'kyc.verificaTitulo': 'Verify your identity',
    'kyc.verificaAyuda': 'It is required to invest and withdraw. You only need three photos and it takes a few minutes.',
    'kyc.soloVerificar': 'Your documents are only used to verify your identity.',
    'kyc.subiendo': 'Uploading…',
    'kyc.enviarDocs': 'Send documents',
    'srv:Documentos subidos correctamente': 'Documents uploaded successfully',
    'clave.cambiar': 'Change password',
    'clave.cambioTitulo': 'Password change',
    'clave.lblConfirmarCorta': 'Confirm password',
    'clave.phAntigua': 'Your old password',
    'clave.phNuevaCorta': 'Your new password',
    'clave.phConfirmarNueva': 'Confirm your new password',
    'clave.guardar': 'Save password',
    'tarjeta.lblNombre': 'First name',
    'tarjeta.lblApellido': 'Last name',
    'tarjeta.lblTipoDoc': 'Document type',
    'tarjeta.lblNumDoc': 'Document number',
    'tarjeta.lblNacimiento': 'Date of birth',
    'tarjeta.lblSexo': 'Sex',
    'tarjeta.lblEstadoCivil': 'Marital status',
    'tarjeta.lblNacionalidad': 'Nationality',
    'tarjeta.lblProfesion': 'Profession or trade',
    'tarjeta.lblCorreo': 'Email',
    'tarjeta.lblTelefono': 'Phone',
    'tarjeta.lblPaisRes': 'Country of residence',
    'tarjeta.lblProvincia': 'Province',
    'tarjeta.lblCiudad': 'City',
    'tarjeta.lblPostal': 'Postal code',
    'tarjeta.lblCalle': 'Street and number',
    'tarjeta.lblComplemento': 'Apartment, house or building (optional)',
    'tarjeta.selPais': 'Select a country',
    'tarjeta.selecciona': 'Select',
    'tarjeta.docCedula': 'National ID',
    'tarjeta.docPasaporte': 'Passport',
    'tarjeta.sexoM': 'Male',
    'tarjeta.sexoF': 'Female',
    'tarjeta.civilSoltero': 'Single',
    'tarjeta.civilCasado': 'Married',
    'tarjeta.civilDivorciado': 'Divorced',
    'tarjeta.civilViudo': 'Widowed',
    'tarjeta.civilUnion': 'Domestic partnership',
    'tarjeta.tuNombre': 'YOUR NAME',
    'tarjeta.titular': 'Cardholder',
    'tarjeta.tarjeta': 'Card',
    'tarjeta.prepago': 'Prepaid',
    'tarjeta.notaEmision': 'Your card is issued in your name. We review each request before approving it.',
    'tarjeta.solicitaTitulo': 'Request your card',
    'tarjeta.solicitaAyuda': 'Confirm your details to request it.',
    'tarjeta.secPersonales': 'Personal details',
    'tarjeta.secContacto': 'Contact',
    'tarjeta.secResidencia': 'Residential address',
    'tarjeta.phTelefono': 'Include country code, e.g. +507 6000 0000',
    'tarjeta.confirmarDatos': 'Confirm details',
    'tarjeta.solicitudEnviada': 'Request sent',
    'tarjeta.revisaDatos': 'Check your details',
    'tarjeta.selOrigen': 'Select the source card',
    'tarjeta.selDestino': 'Select the destination card',
    'tarjeta.montoValido': 'Enter a valid amount',
    'tarjeta.mismaTarjeta': 'You cannot transfer to the same card',
    'tarjeta.transferOk': 'Transfer completed successfully!',
    'tarjeta.transferError': 'Error making the transfer',
    'tarjeta.volverListado': 'Back to the card list',
    'tarjeta.transferirTitulo': 'Transfer between cards',
    'tarjeta.lblOrigen': 'Source Card',
    'tarjeta.lblDestino': 'Destination Card',
    'tarjeta.seleccioneTarjeta': 'Select a card',
    'tarjeta.lblMonto': 'Amount to transfer',
    'tarjeta.lblDescripcion': 'Description (optional)',
    'tarjeta.phDescripcion': 'E.g. Investment payment',
    'tarjeta.transferirBtn': '💰 Transfer',
    'tarjeta.transferExitosa': '✅ Transfer Successful',
    'tarjeta.atencion': '⚠️ Attention',
    'tarjeta.cancelada': 'Done, the card has been cancelled.',
    'tarjeta.noCancelada': 'We could not cancel the card. Please try again.',
    'tarjeta.completaCampos': 'Please complete these fields: {campos}.',
    'tarjeta.datosActualizados': 'Details updated successfully! Please wait for approval.',
    'tarjeta.errorActualizar': 'Error updating',
    'tarjeta.tabLista': 'Card List',
    'tarjeta.tabAgregar': 'Add Card',
    'tarjeta.tabTransferir': 'Transfer',
    'tarjeta.desactivarTitulo': 'Deactivate card',
    'tarjeta.cancelarSolicitud': 'Cancel request',
    'tarjeta.desactivarAviso': 'The card will no longer be available. This action cannot be undone.',
    'tarjeta.cancelarAviso': 'We will stop processing this request. You can request another card whenever you like.',
    'tarjeta.motivo': 'Reason (optional)',
    'tarjeta.volver': 'Back',
    'tarjeta.procesando': 'Processing…',
    'tarjeta.confirmar': 'Confirm',
    'tarjeta.descargarMov': 'Download transactions',
    'tarjeta.desde': 'From',
    'tarjeta.hasta': 'To',
    'tarjeta.cerrar': 'Close',
    'tarjeta.generando': 'Generating…',
    'tarjeta.excel': 'Excel',
    'tarjeta.pdf': 'PDF',
    'tarjeta.sinTarjetas': 'You don\'t have any cards yet',
    'tarjeta.sinTarjetasAyuda': 'Request your Panther7 card and use it with your USDT balance.',
    'tarjeta.solicitar': 'Request card',
    'tarjeta.misTarjetas': 'My cards',
    'tarjeta.solicitarOtra': 'Request another card',
    'tarjeta.numDisponible': 'Number available once issued',
    'tarjeta.sinNombre': 'No name',
    'tarjeta.enProceso': 'IN PROGRESS',
    'tarjeta.saldo': 'Balance',
    'tarjeta.detalles': 'Details',
    'tarjeta.desactivar': 'Deactivate',
    'tarjeta.notaRevision': 'We review each request. We will email you when it is ready.',
    'tarjeta.dBloqueado': 'Blocked balance:',
    'tarjeta.dTransito': 'Transaction balance:',
    'tarjeta.dNumero': 'Card number:',
    'tarjeta.dEstatus': 'Status:',
    'tarjeta.dCreado': 'Created on:',
    'tarjeta.dActualizado': 'Updated on:',
    'tarjeta.dTransacciones': 'transactions',
    'tarjeta.dReferencia': 'Reference:',
    'tarjeta.dCreadoPor': 'Created by:',
    'tarjeta.dDescripcion': 'Description:',
    'tarjeta.dCantidad': 'Amount:',
    'tarjeta.dNinguno': 'none',
    'tarjeta.dNone': 'None',
    'tarjeta.mes1': 'January',
    'tarjeta.mes2': 'February',
    'tarjeta.mes3': 'March',
    'tarjeta.mes4': 'April',
    'tarjeta.mes5': 'May',
    'tarjeta.mes6': 'June',
    'tarjeta.mes7': 'July',
    'tarjeta.mes8': 'August',
    'tarjeta.mes9': 'September',
    'tarjeta.mes10': 'October',
    'tarjeta.mes11': 'November',
    'tarjeta.mes12': 'December',
    'srv:no se pudo crear la solicitud': 'the request could not be created',
    'srv:No pudimos registrar tu solicitud. Intenta de nuevo en unos minutos.': 'We could not register your request. Please try again in a few minutes.',
    'srv:No encontramos esa tarjeta.': 'We could not find that card.',
    'srv:Esa tarjeta ya está cancelada.': 'That card is already cancelled.',
    'srv:Request created': 'Request created',
    'srv:Card desactivate': 'Card deactivated',
    'srv:PENDIENTE': 'PENDING',
    'srv:APROBADO': 'APPROVED',
    'srv:RECHAZADO': 'REJECTED',
    'srv:EN REVISIÓN': 'UNDER REVIEW',
    'srv:EN PROCESO': 'IN PROGRESS',
    'srv:CANCELADO': 'CANCELLED',
    'asistente.depositar.titulo': 'How do I deposit?',
    'asistente.depositar.texto': 'You can deposit with crypto (USDT to the Panther wallet) or by ACH from a bank in Panama. Each USDT equals 1 USDT in your account, with no fee. Your deposit stays pending until the team verifies and approves it.',
    'asistente.depositar.ir': 'Go to Deposit',
    'asistente.retirar.titulo': 'How do I withdraw?',
    'asistente.retirar.texto': 'Go to Withdrawal, choose a wallet or bank account you have saved, and the amount. Withdrawals have no fee and are reviewed before being sent, so you will get an email once they are approved.',
    'asistente.retirar.ir': 'Go to Withdrawal',
    'asistente.invertir.titulo': 'How do I invest?',
    'asistente.invertir.texto': 'In Projects you can see what is available. Choose one, enter the amount and confirm; it is deducted from your available balance. Always review the terms of each project before confirming. I do not give investment recommendations.',
    'asistente.invertir.ir': 'View projects',
    'asistente.saldo.titulo': 'How much do I have?',
    'asistente.saldo.texto': 'Available: {disponible}. Invested: {invertido}. Your account value: {valor}.',
    'asistente.saldo.error': 'I could not read your balance right now. Check the Home screen.',
    'asistente.saldo.ir': 'Go to Home',
    'asistente.movimientos.titulo': 'View my transactions',
    'asistente.movimientos.texto': 'In Transactions you can see all your deposits, withdrawals and investments with their status.',
    'asistente.movimientos.ir': 'Go to Transactions',
    'asistente.wallet.titulo': 'My wallet',
    'asistente.wallet.texto': 'Your wallet and the addresses you saved are in Blockchain Wallet. Double-check each address before sending: crypto transfers cannot be reversed.',
    'asistente.wallet.ir': 'Go to Wallet',
    'asistente.verificacion.titulo': 'Verify my account',
    'asistente.verificacion.texto': 'Complete your details and upload your documents in My account. The team reviews them and emails you once your account is approved.',
    'asistente.cuenta.ir': 'Go to My account',
    'asistente.clave.titulo': 'Change my password',
    'asistente.clave.texto': 'You can change your password from My account. Never share your password with anyone, not even the Panther7 team.',
    'asistente.comision.titulo': 'Are there any fees?',
    'asistente.comision.texto': 'Deposits and withdrawals have no fee. Everything is shown in USDT.',
    'asistente.humano': 'I do not have a reliable answer for that. It is better to have someone on the team help you: write to us at {correo}.',
    'asistente.saludo': 'Hi, I am the Panther7 assistant. How can I help you?',
    'asistente.aria': 'Panther7 assistant',
    'asistente.preguntame': 'Ask me',
    'asistente.cerrar': 'Close',
    'asistente.escribe': 'Type your question',
    'asistente.enviar': 'Send',
    'asistente.pie': 'I do not give investment advice or move money.',
    'asistente.hablar': 'Talk to a person',
    'asistente.soporte': 'Write to support',
    'asistente.abrir': 'Open assistant',
  },
  pt: {
    'cuenta.tabDatos': 'Meus dados',
    'cuenta.tabVerificacion': 'Central de verificação',
    'kyc.queEsTitulo': 'O que é KYC e para que serve?',
    'kyc.queEsP1': 'KYC é o nome dado ao processo de verificação da identidade de um cliente. Esse termo, que está se tornando uma expressão comum, vem do setor bancário. As instituições financeiras sempre precisam poder identificar seus clientes ao abrir uma nova conta.',
    'kyc.queEsP2': 'Os objetivos das diretrizes de KYC são evitar que bancos ou instituições financeiras sejam usados, intencionalmente ou não, por elementos criminosos para atividades de lavagem de dinheiro. Os procedimentos relacionados também permitem que os bancos entendam melhor seus clientes e suas transações financeiras.',
    'cuenta.anadirWallet': 'Adicionar carteira',
    'cuenta.anadirCuenta': 'Adicionar conta',
    'cuenta.anadirPrimeraWallet': 'Adicionar minha primeira carteira',
    'cuenta.anadirPrimera': 'Adicionar a primeira',
    'cuenta.banco': 'Banco',
    'cuenta.cuentaTipo': 'Conta',
    'cuenta.eliminarNombre': 'Excluir {nombre}',
    'cuenta.eliminando': 'Excluindo…',
    'cuenta.eliminar': 'Excluir',
    'cuenta.cuentaGuardada': 'Conta salva.',
    'cuenta.confirmarEliminar': 'Excluir {nombre}?',
    'cuenta.cuentaEliminada': 'Conta excluída.',
    'cuenta.noSeEliminoCuenta': 'Não foi possível excluir a conta.',
    'cuenta.walletsTitulo': 'Carteiras USDT',
    'cuenta.walletsAyuda': 'Os saques em USDT são enviados apenas para estas carteiras.',
    'cuenta.walletsVacio': 'Você ainda não tem carteiras salvas.',
    'cuenta.panamaTitulo': 'Contas no Panamá',
    'cuenta.panamaAyuda': 'Suas contas bancárias locais.',
    'cuenta.panamaVacio': 'Você ainda não tem contas no Panamá.',
    'cuenta.internacionalesTitulo': 'Contas internacionais',
    'cuenta.internacionalesAyuda': 'Contas em bancos fora do Panamá.',
    'cuenta.internacionalesVacio': 'Você ainda não tem contas internacionais.',
    'srv:Beneficiario desactivado correctamente': 'Beneficiário desativado com sucesso',
    'srv:Beneficiario creado correctamente': 'Beneficiário criado com sucesso',
    'srv:Beneficiario actualizado correctamente': 'Beneficiário atualizado com sucesso',
    'srv:Esa wallet ya está guardada.': 'Essa carteira já está salva.',
    'cuenta.perfilDe': 'Perfil de',
    'cuenta.usuario': 'Usuário',
    'cuenta.plataforma': 'Plataforma de Crescimento Financeiro',
    'cuenta.tabDatosPersonales': 'Meus Dados Pessoais',
    'cuenta.tabPrivacidad': 'Privacidade e Segurança',
    'cuenta.tabCuentasBancarias': 'Contas Bancárias',
    'cuenta.sinAgregar': 'Não informado',
    'cuenta.actualizacionTitulo': 'Atualização dos meus dados pessoais',
    'cuenta.bienvenida1': 'Bem-vindo à sua plataforma favorita de investimentos,',
    'cuenta.bienvenida2': 'por favor, preencha',
    'cuenta.bienvenida3': 'os campos a seguir com seus dados pessoais para poder aproveitar a',
    'cuenta.obligatorios': 'Os campos com asterisco são obrigatórios *',
    'cuenta.lblNombreUsuario': '👤 Nome de usuário:',
    'cuenta.lblCorreo': '📧 E-mail:',
    'cuenta.lblReferido': '🔗 Código de indicação:',
    'cuenta.lblDocumento': '🆔 Documento de identidade:',
    'cuenta.lblSexo': '⚥ Sexo:',
    'cuenta.lblSituacionLaboral': '💼 Situação profissional:',
    'cuenta.lblEmpresa': '🏢 Empresa onde trabalha:',
    'cuenta.lblNacimiento': '🎂 Data de nascimento:',
    'cuenta.contactoTitulo': 'Informações de contato',
    'cuenta.contactoAyuda': 'Preencha seus dados de contato e endereço',
    'cuenta.lblCelular': '📱 Número de celular:',
    'cuenta.lblDireccion': '🏠 Endereço principal:',
    'cuenta.lblCalle': '📍 Endereço (rua):',
    'cuenta.lblPostal': '✉️ Código postal:',
    'cuenta.lblPais': '🌎 País:',
    'cuenta.lblProvincia': '🏞️ Província:',
    'cuenta.lblCiudad': '🏙️ Cidade:',
    'cuenta.completarInfo': '📝 Completar informações',
    'cuenta.completeInfoPersonal': 'Complete suas informações pessoais',
    'clave.errorCambiar': 'Erro ao alterar a senha',
    'clave.todosObligatorios': 'Todos os campos são obrigatórios',
    'clave.noCoincidenNuevas': 'As novas senhas não coincidem',
    'clave.minimo8': 'A nova senha deve ter pelo menos 8 caracteres',
    'clave.cambiarBtn': '🔒 Alterar senha',
    'clave.debil': 'Fraca',
    'clave.media': 'Média',
    'clave.fuerte': 'Forte',
    'clave.privacidadTitulo': 'Privacidade e Segurança',
    'clave.privacidadAyuda1': 'Para nós, a sua',
    'clave.privacidadAyuda2': 'privacidade e segurança',
    'clave.privacidadAyuda3': 'é muito importante',
    'clave.recomendacion1': 'Recomendamos atualizar sua senha uma vez',
    'clave.recomendacion2': 'a cada 30 dias',
    'clave.consejo': 'Uma senha segura deve ter pelo menos 8 caracteres, incluindo letras maiúsculas e minúsculas, números e caracteres especiais.',
    'clave.lblActual': 'Senha atual',
    'clave.phActual': 'Digite sua senha atual',
    'clave.lblNueva': 'Nova senha',
    'clave.phNueva': 'Digite sua nova senha',
    'clave.fortaleza': 'Força:',
    'clave.lblConfirmar': 'Confirmar nova senha',
    'clave.phConfirmar': 'Confirme sua nova senha',
    'clave.noCoinciden': 'As senhas não coincidem',
    'clave.actualizarMi': 'Atualizar minha senha',
    'srv:Su contraseña actual no coincide con la contraseña que proporcionó. Inténtalo de nuevo..': 'Sua senha atual não corresponde à senha que você informou. Tente novamente.',
    'srv:La nueva contraseña no puede ser la misma que su contraseña actual. Elija una contraseña diferente.': 'A nova senha não pode ser igual à sua senha atual. Escolha uma senha diferente.',
    'srv:Password changed successfully !': 'Senha alterada com sucesso!',
    'srv:Sua senha atual não corresponde à senha que você forneceu. Por favor, tente novamente.': 'Sua senha atual não corresponde à senha que você forneceu. Por favor, tente novamente.',
    'srv:Nova senha não pode ser igual à sua senha atual. Por favor, escolha uma senha diferente.': 'Nova senha não pode ser igual à sua senha atual. Por favor, escolha uma senha diferente.',
    'alerta.listo': 'Pronto',
    'alerta.revisa': 'Confira isto',
    'alerta.aceptar': 'Aceitar',
    'cuenta.actualizarInfo': 'Atualizar minhas informações',
    'cuenta.fSituacion': 'Situação profissional',
    'cuenta.fEmpresa': 'Empresa onde trabalha',
    'cuenta.fOcupacion': 'Ocupação profissional',
    'cuenta.fNombreApellido': 'Nome e sobrenome',
    'cuenta.fDocumento': 'Documento de identidade',
    'cuenta.fNacimiento': 'Data de Nascimento',
    'cuenta.fSexo': 'Sexo',
    'cuenta.fEstadoCivil': 'Estado Civil',
    'cuenta.fPais': 'País',
    'cuenta.fProvincia': 'Província',
    'cuenta.fCiudad': 'Cidade',
    'cuenta.fDireccion': 'Endereço',
    'cuenta.fDireccionCompl': 'Complemento do endereço',
    'cuenta.fPostal': 'Código Postal',
    'srv:Cliente actualizado. ': 'Cliente atualizado. ',
    'srv:No es posible actualizar el cliente': 'Não é possível atualizar o cliente',
    'kyc.docTitulo': 'Documento de identidade',
    'kyc.docAyuda': 'RG, cédula ou passaporte, pelo lado da foto. O documento inteiro à vista e sem reflexos.',
    'kyc.resTitulo': 'Comprovante de residência',
    'kyc.resAyuda': 'Uma conta de serviços ou extrato recente, em seu nome.',
    'kyc.selfieTitulo': 'Selfie',
    'kyc.selfieAyuda': 'Uma foto sua de frente, com boa iluminação e sem óculos escuros.',
    'kyc.vistaPrevia': 'Pré-visualização de {titulo}',
    'kyc.cambiar': 'Alterar',
    'kyc.elegirArchivo': 'Escolher arquivo',
    'kyc.formatosMax': 'JPG, PNG ou PDF · até {max} MB',
    'kyc.formatoNoPermitido': 'Formato não permitido. Use JPG, PNG ou PDF.',
    'kyc.superaMax': 'O arquivo excede {max} MB.',
    'kyc.enviados': 'Documentos enviados.',
    'kyc.errorSubir': 'Não foi possível enviar seus documentos. Verifique sua conexão e tente novamente.',
    'kyc.recibidosTitulo': 'Documentos recebidos',
    'kyc.recibidosDetalle': '{texto}. Vamos analisá-los e sua conta será habilitada após a aprovação.',
    'kyc.continuar': 'Continuar',
    'kyc.verificaTitulo': 'Verifique sua identidade',
    'kyc.verificaAyuda': 'É um requisito para investir e sacar. Você só precisa de três fotos e leva poucos minutos.',
    'kyc.soloVerificar': 'Seus documentos são usados apenas para verificar sua identidade.',
    'kyc.subiendo': 'Enviando…',
    'kyc.enviarDocs': 'Enviar documentos',
    'srv:Documentos subidos correctamente': 'Documentos enviados com sucesso',
    'clave.cambiar': 'Alterar senha',
    'clave.cambioTitulo': 'Alteração de senha',
    'clave.lblConfirmarCorta': 'Confirmar senha',
    'clave.phAntigua': 'Sua senha antiga',
    'clave.phNuevaCorta': 'Sua nova senha',
    'clave.phConfirmarNueva': 'Confirme sua nova senha',
    'clave.guardar': 'Salvar senha',
    'tarjeta.lblNombre': 'Nome',
    'tarjeta.lblApellido': 'Sobrenome',
    'tarjeta.lblTipoDoc': 'Tipo de documento',
    'tarjeta.lblNumDoc': 'Número do documento',
    'tarjeta.lblNacimiento': 'Data de nascimento',
    'tarjeta.lblSexo': 'Sexo',
    'tarjeta.lblEstadoCivil': 'Estado civil',
    'tarjeta.lblNacionalidad': 'Nacionalidade',
    'tarjeta.lblProfesion': 'Profissão ou ofício',
    'tarjeta.lblCorreo': 'E-mail',
    'tarjeta.lblTelefono': 'Telefone',
    'tarjeta.lblPaisRes': 'País de residência',
    'tarjeta.lblProvincia': 'Província',
    'tarjeta.lblCiudad': 'Cidade',
    'tarjeta.lblPostal': 'Código postal',
    'tarjeta.lblCalle': 'Rua e número',
    'tarjeta.lblComplemento': 'Apartamento, casa ou edifício (opcional)',
    'tarjeta.selPais': 'Selecione um país',
    'tarjeta.selecciona': 'Selecione',
    'tarjeta.docCedula': 'Cédula/DNI',
    'tarjeta.docPasaporte': 'Passaporte',
    'tarjeta.sexoM': 'Masculino',
    'tarjeta.sexoF': 'Feminino',
    'tarjeta.civilSoltero': 'Solteiro',
    'tarjeta.civilCasado': 'Casado',
    'tarjeta.civilDivorciado': 'Divorciado',
    'tarjeta.civilViudo': 'Viúvo',
    'tarjeta.civilUnion': 'União estável',
    'tarjeta.tuNombre': 'SEU NOME',
    'tarjeta.titular': 'Titular',
    'tarjeta.tarjeta': 'Cartão',
    'tarjeta.prepago': 'Pré-pago',
    'tarjeta.notaEmision': 'Seu cartão é emitido em seu nome. Analisamos cada solicitação antes de aprová-la.',
    'tarjeta.solicitaTitulo': 'Solicite seu cartão',
    'tarjeta.solicitaAyuda': 'Confirme seus dados para solicitá-lo.',
    'tarjeta.secPersonales': 'Dados pessoais',
    'tarjeta.secContacto': 'Contato',
    'tarjeta.secResidencia': 'Endereço de residência',
    'tarjeta.phTelefono': 'Com código do país, ex.: +507 6000 0000',
    'tarjeta.confirmarDatos': 'Confirmar dados',
    'tarjeta.solicitudEnviada': 'Solicitação enviada',
    'tarjeta.revisaDatos': 'Confira seus dados',
    'tarjeta.selOrigen': 'Selecione o cartão de origem',
    'tarjeta.selDestino': 'Selecione o cartão de destino',
    'tarjeta.montoValido': 'Informe um valor válido',
    'tarjeta.mismaTarjeta': 'Você não pode transferir para o mesmo cartão',
    'tarjeta.transferOk': 'Transferência realizada com sucesso!',
    'tarjeta.transferError': 'Erro ao realizar a transferência',
    'tarjeta.volverListado': 'Voltar à lista de cartões',
    'tarjeta.transferirTitulo': 'Transferir entre cartões',
    'tarjeta.lblOrigen': 'Cartão de Origem',
    'tarjeta.lblDestino': 'Cartão de Destino',
    'tarjeta.seleccioneTarjeta': 'Selecione um cartão',
    'tarjeta.lblMonto': 'Valor a transferir',
    'tarjeta.lblDescripcion': 'Descrição (opcional)',
    'tarjeta.phDescripcion': 'Ex.: Pagamento de investimento',
    'tarjeta.transferirBtn': '💰 Transferir',
    'tarjeta.transferExitosa': '✅ Transferência Bem-sucedida',
    'tarjeta.atencion': '⚠️ Atenção',
    'tarjeta.cancelada': 'Pronto, o cartão foi cancelado.',
    'tarjeta.noCancelada': 'Não foi possível cancelar o cartão. Tente novamente.',
    'tarjeta.completaCampos': 'Preencha estes campos: {campos}.',
    'tarjeta.datosActualizados': 'Dados atualizados com sucesso! Aguarde a aprovação.',
    'tarjeta.errorActualizar': 'Erro ao atualizar',
    'tarjeta.tabLista': 'Lista de Cartões',
    'tarjeta.tabAgregar': 'Adicionar Cartão',
    'tarjeta.tabTransferir': 'Transferir',
    'tarjeta.desactivarTitulo': 'Desativar cartão',
    'tarjeta.cancelarSolicitud': 'Cancelar solicitação',
    'tarjeta.desactivarAviso': 'O cartão deixará de estar disponível. Esta ação não pode ser desfeita.',
    'tarjeta.cancelarAviso': 'Deixaremos de processar esta solicitação. Você poderá pedir outro cartão quando quiser.',
    'tarjeta.motivo': 'Motivo (opcional)',
    'tarjeta.volver': 'Voltar',
    'tarjeta.procesando': 'Processando…',
    'tarjeta.confirmar': 'Confirmar',
    'tarjeta.descargarMov': 'Baixar movimentações',
    'tarjeta.desde': 'De',
    'tarjeta.hasta': 'Até',
    'tarjeta.cerrar': 'Fechar',
    'tarjeta.generando': 'Gerando…',
    'tarjeta.excel': 'Excel',
    'tarjeta.pdf': 'PDF',
    'tarjeta.sinTarjetas': 'Você ainda não tem cartões',
    'tarjeta.sinTarjetasAyuda': 'Solicite seu cartão Panther7 e use-o com seu saldo em USDT.',
    'tarjeta.solicitar': 'Solicitar cartão',
    'tarjeta.misTarjetas': 'Meus cartões',
    'tarjeta.solicitarOtra': 'Solicitar outro cartão',
    'tarjeta.numDisponible': 'Número disponível quando for emitido',
    'tarjeta.sinNombre': 'Sem nome',
    'tarjeta.enProceso': 'EM ANDAMENTO',
    'tarjeta.saldo': 'Saldo',
    'tarjeta.detalles': 'Detalhes',
    'tarjeta.desactivar': 'Desativar',
    'tarjeta.notaRevision': 'Analisamos cada solicitação. Avisaremos por e-mail quando estiver pronto.',
    'tarjeta.dBloqueado': 'Saldo bloqueado:',
    'tarjeta.dTransito': 'Saldo em trânsito:',
    'tarjeta.dNumero': 'Número do cartão:',
    'tarjeta.dEstatus': 'Status:',
    'tarjeta.dCreado': 'Criado em:',
    'tarjeta.dActualizado': 'Atualizado em:',
    'tarjeta.dTransacciones': 'transações',
    'tarjeta.dReferencia': 'Referência:',
    'tarjeta.dCreadoPor': 'Criado por:',
    'tarjeta.dDescripcion': 'Descrição:',
    'tarjeta.dCantidad': 'Quantidade:',
    'tarjeta.dNinguno': 'nenhum',
    'tarjeta.dNone': 'Nenhum',
    'tarjeta.mes1': 'janeiro',
    'tarjeta.mes2': 'fevereiro',
    'tarjeta.mes3': 'março',
    'tarjeta.mes4': 'abril',
    'tarjeta.mes5': 'maio',
    'tarjeta.mes6': 'junho',
    'tarjeta.mes7': 'julho',
    'tarjeta.mes8': 'agosto',
    'tarjeta.mes9': 'setembro',
    'tarjeta.mes10': 'outubro',
    'tarjeta.mes11': 'novembro',
    'tarjeta.mes12': 'dezembro',
    'srv:no se pudo crear la solicitud': 'não foi possível criar a solicitação',
    'srv:No pudimos registrar tu solicitud. Intenta de nuevo en unos minutos.': 'Não foi possível registrar sua solicitação. Tente novamente em alguns minutos.',
    'srv:No encontramos esa tarjeta.': 'Não encontramos esse cartão.',
    'srv:Esa tarjeta ya está cancelada.': 'Esse cartão já está cancelado.',
    'srv:Request created': 'Solicitação criada',
    'srv:Card desactivate': 'Cartão desativado',
    'srv:PENDIENTE': 'PENDENTE',
    'srv:APROBADO': 'APROVADO',
    'srv:RECHAZADO': 'REJEITADO',
    'srv:EN REVISIÓN': 'EM ANÁLISE',
    'srv:EN PROCESO': 'EM ANDAMENTO',
    'srv:CANCELADO': 'CANCELADO',
    'asistente.depositar.titulo': 'Como faço um depósito?',
    'asistente.depositar.texto': 'Você pode depositar por cripto (USDT para a carteira da Panther) ou por ACH de um banco do Panamá. Cada USDT equivale a 1 USDT na sua conta, sem comissão. Seu depósito fica pendente até que a equipe o verifique e aprove.',
    'asistente.depositar.ir': 'Ir para Depósito',
    'asistente.retirar.titulo': 'Como faço um saque?',
    'asistente.retirar.texto': 'Acesse Saque, escolha uma carteira ou conta bancária que você tenha salva e o valor. Os saques não têm comissão e são analisados antes de serem enviados, então você receberá um e-mail quando forem aprovados.',
    'asistente.retirar.ir': 'Ir para Saque',
    'asistente.invertir.titulo': 'Como faço para investir?',
    'asistente.invertir.texto': 'Em Projetos você vê o que está disponível. Escolha um, informe o valor e confirme; ele é descontado do seu saldo disponível. Sempre revise as condições de cada projeto antes de confirmar. Eu não dou recomendações de investimento.',
    'asistente.invertir.ir': 'Ver projetos',
    'asistente.saldo.titulo': 'Quanto eu tenho?',
    'asistente.saldo.texto': 'Disponível: {disponible}. Investido: {invertido}. Valor da sua conta: {valor}.',
    'asistente.saldo.error': 'Não consegui ler seu saldo agora. Confira a tela de Início.',
    'asistente.saldo.ir': 'Ir para Início',
    'asistente.movimientos.titulo': 'Ver minhas movimentações',
    'asistente.movimientos.texto': 'Em Movimentações você vê todos os seus depósitos, saques e investimentos com o respectivo status.',
    'asistente.movimientos.ir': 'Ir para Movimentações',
    'asistente.wallet.titulo': 'Minha carteira',
    'asistente.wallet.texto': 'Sua carteira e os endereços que você salvou estão em Carteira Blockchain. Confira bem cada endereço antes de enviar: as transferências cripto não podem ser revertidas.',
    'asistente.wallet.ir': 'Ir para Carteira',
    'asistente.verificacion.titulo': 'Verificar minha conta',
    'asistente.verificacion.texto': 'Preencha seus dados e envie seus documentos em Minha conta. A equipe os analisa e avisa por e-mail quando sua conta for aprovada.',
    'asistente.cuenta.ir': 'Ir para Minha conta',
    'asistente.clave.titulo': 'Alterar minha senha',
    'asistente.clave.texto': 'Você pode alterar sua senha em Minha conta. Nunca compartilhe sua senha com ninguém, nem mesmo com a equipe da Panther7.',
    'asistente.comision.titulo': 'Existem comissões?',
    'asistente.comision.texto': 'Os depósitos e saques não têm comissão. Tudo é exibido em USDT.',
    'asistente.humano': 'Não tenho uma resposta segura para isso. É melhor ser atendido por uma pessoa da equipe: escreva para {correo}.',
    'asistente.saludo': 'Olá, sou o assistente da Panther7. Como posso ajudar?',
    'asistente.aria': 'Assistente Panther7',
    'asistente.preguntame': 'Pergunte-me',
    'asistente.cerrar': 'Fechar',
    'asistente.escribe': 'Digite sua pergunta',
    'asistente.enviar': 'Enviar',
    'asistente.pie': 'Não dou consultoria de investimento nem movimento dinheiro.',
    'asistente.hablar': 'Falar com uma pessoa',
    'asistente.soporte': 'Escrever para o suporte',
    'asistente.abrir': 'Abrir assistente',
  },
};
